var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconOption = function SvgIconOption(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6.26mm",
    height: "6.13mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.75 17.39",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.33,14.26H1.38c-.11,0-.2-.09-.2-.21V1.36c0-.11.09-.2.2-.2h13.01c.11,0,.2.09.2.2v5.92l1,.27V1.36c0-.66-.54-1.2-1.2-1.2H1.38C.72.16.18.7.18,1.36v12.69c0,.66.54,1.21,1.2,1.21h6.18l-.23-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98,17.23s-.08,0-.11,0c-.44-.05-.79-.35-.9-.77l-2.39-8.94c-.1-.37,0-.75.27-1.01.27-.27.64-.37,1.01-.27l8.94,2.39c.42.11.73.47.77.9s-.18.85-.57,1.04l-4.01,2.05-2.07,4.04c-.18.36-.54.57-.93.57ZM7.54,7.26l2.39,8.94,2.14-4c.1-.2.26-.36.46-.46l4.02-2.05-8.95-2.49-.06.06h0Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconOption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-option.86316b1fe8a22f71c663702df322999e.svg";